import PropTypes from 'prop-types';
import HighCharts from '../HighCharts';

import s from './TimelineChartBlock.module.css';

const TimelineChartBlock = (props) => {
    const {
        title,
        color,
        displayLargeTitle,
        showTitleInToc,
        dateOrdering,
        dateFormattting,
        spacePointsEvenly,

        propertySeriesQueries,
    } = props;

    return (
        <div className={s.Root}>
            <HighCharts
                chartType="timeline"
                title={title}
                showTitleInToc={showTitleInToc}
                displayLargeTitle={displayLargeTitle}
                timelineColor={color}
                timelineSpacePointsEvenly={spacePointsEvenly}
                timelineDateOrdering={dateOrdering}
                timelineDateFormatting={dateFormattting}
                propertySeriesQueries={propertySeriesQueries}
            />
        </div>
    );
};

TimelineChartBlock.propTypes = {
    title: PropTypes.string,
    displayLargeTitle: PropTypes.bool,
    showTitleInToc: PropTypes.bool,
    spacePointsEvenly: PropTypes.bool,
    dateOrdering: PropTypes.string,
    dateFormattting: PropTypes.string,
    propertySeriesQueries: PropTypes.array,
};

export default TimelineChartBlock;
